export default {
  title: 'Zaloguj się pod własnym adresem',
  description:
    'Ten adres należy do partnera, do którego to konto nie należy. Dla bezpieczeństwa konta zaloguj się tam, gdzie zwykle — e-mail i hasło działają tam tak samo.',
  continue: 'Przejdź do {{host}}',
  password_changed: 'Hasło zostało zmienione.',
};
